import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
// import {TableComp} from 'sz-react-utils'
import TableComp from "../../../../components/_utils/table";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import lodash from "lodash";
import ListFollowUps from "../../../../components/_utils/listRawInquiryFollowUp";
import SyncSpreadsheetForm from "../../../../components/_utils/syncSpreadsheetForm";
import ClickToCallDrawer from '../../../Student/inquiry/all/clickToCall';
import LatestFollowUp from "../../../../components/_utils/latestRawFollowup";
import moment from "moment";
import {
  Button,
  Card,
  Drawer,
  Form,
  notification,
  Popconfirm,
  DatePicker,
  Select,
  Tooltip,
  Checkbox,
  Row,
  Col,
} from "antd";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import _ from "lodash";

import styles from "./style.less";
import { connect } from "react-redux";
import common from "../../../common.less";
import { getUrlPushWrapper } from "../../../../routes";
import { RightsWrapper } from "../../../../components/_utils/utils";
import RawInquiryExcel from "../../../../assets/samplesFiles/RawInquiryImport.xlsx";

import { hideLoader, showLoader } from "../../../../modules/actions";

import rightAuth from "../../../../components/_utils/userRights";
import EmailDrawer from "../../../../components/communication/emailDrawer";
import SMS from "../../../../components/communication/sms";
import WhatsAPPSMS from "../../../../components/communication/WhatsAppSms";
const Option = Select.Option;
const { RangePicker } = DatePicker;
let studentObj = {};
let userCheckBox = {};
let counsellingData = {};
const todayDate = moment().format("YYYYMMDD");
let dateFormat = localStorage.getItem("company-details")
  ? JSON.parse(localStorage.getItem("company-details")).dateFormat
  : "DD.MM.YYYY";
let sourceOptions = [
  "Direct",
  "Newspaper",
  "Facebook",
  "Google",
  "Seminar",
  "Education Fair",
  "School/College Event",
  "Conopy",
  "Instagram",
  "Justdial",
  "Website",
  "Friend Reference",
];

@Form.create()
class MoveMultipleInquiries extends Component {
  state = {
    visible: true,
    counsellorId: "",
    loading: false,
  };

  onClose = () => {
    this.setState({ visible: false });
    setTimeout(() => {
      this.props.onClose();
    }, 50);
  };



  handleSubmit = async () => {
    let { selectedUsers, assignCounsellorUsers } = this.props;
    let { counsellorId } = this.state;
    let response = null;
    this.setState({ loading: true });
    if (selectedUsers && selectedUsers.length > 0) {
      let dataToSend = {
        selectedUsers,
        counsellorId,
      };
      response = await Request.moveMultipleRawInquiries(dataToSend);
    } else if (!selectedUsers.length && assignCounsellorUsers.length > 0) {
      let dataToSend = {
        assignCounsellorUsers,
        counsellorId,
      };
      response = await Request.assignCounsellors(dataToSend);
    }

    this.setState({ loading: false });
    if (response.success) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
    this.onClose();
  };

  componentDidMount() { }

  render() {
    let {
      form: { getFieldDecorator },
      allCounsellor,
      selectedUsers,
    } = this.props;
    return (
      <Drawer
        title=""
        placement="right"
        closable={true}
        onClose={this.onClose}
        visible={this.state.visible}
        width={500}
      >
        <div>
          <Card style={{ marginBottom: "10px" }}>
            <h2
              style={{
                marginLeft: "11px",
                marginTop: "13px",
                color: "orange",
              }}
            >
              Choose Counsellor
            </h2>

            <div>
              <Select
                showSearch={true}
                allowClear
                optionFilterProp="children"
                style={{
                  width: 214,
                  paddingRight: 16,
                  paddingLeft: 9,
                }}
                value={
                  this.state.counsellorId ? this.state.counsellorId : undefined
                }
                placeholder="Select Counsellor"
                onChange={(counsellorId) => {
                  this.setState({
                    counsellorId: counsellorId && counsellorId.toString(),
                  });
                }}
              >
                {allCounsellor.map((val, idn) => {
                  return (
                    <Option key={idn} value={val._id}>
                      {val.name}
                    </Option>
                  );
                })}
              </Select>
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => this.handleSubmit()}
                style={{ marginLeft: "1%" }}
                loading={this.state.loading}
              >
                SAVE
              </Button>
            </div>
          </Card>
        </div>
      </Drawer>
    );
  }
}

@Form.create()
class AllRawInquiry extends Component {
  state = {
    count: 0,
    followDuesCount: 0,
    showFollowUp: false,
    visible: false,
    visible1: false,
    showSyncForm: false,
    allCounsellor: [],
    counsellorId: null,
    inquiryId: null,
    userCheckBox: {},
    exportParams: {},
    showDate: true,
    rawInquiryData: {},
    showEmail: false,
    showSMS: false,
    showWhatsAppSms: false,
    isFollowUpOverdue: false,
    assignCounsellorUsers: [],
    campaignNamesArr: [],
    showCallDrawer: false,
    recordForCall: {},
    counsellorReassigned: false,
    time: {
      key: "time",
      $gte: "",
      $lt: "",
    },
    allStatus: ["Active", "Inactive"],
    modeArr: [],
    allTestTypes: [
      {
        value: "ielts",
        text: "IELTS",
      },
      {
        value: "pte",
        text: "PTE",
      },
      {
        value: "no",
        text: "NO",
      },
    ],
    allBranches: [],
    followUpTypes: [
      "Active",
      "Dead",
      "B2B",
      "Didn't Pick up Call",
      "Busy, Call Later",
      "Not Interested",
      "Out Of town",
      "Job",
      "Number out of service",
      "Number not connected",
      "Final design pending",
      "Spouse Visa",
      "Work Visa",
      "Another query",
      "Enrolled",
    ],
    showMoveMultipleInquiries: false,
    selectedUsers: [],
    showDropped: false,
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
  }

  getAllFollowUpTypes = async () => {
    let params = {
      results: 10000,
      count: 10000,
    };
    let response = await Request.getFollowUpTypes(params);
    let followUpObject = [];
    response.data &&
      response.data.map((followUp) => {
        followUpObject.push(followUp.name);
      });
    this.setState({ followUpTypes: followUpObject });
  };

  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000,
    });
    let sourceObject = [];
    response.data &&
      response.data.map((source) => {
        sourceObject.push(source.sourceName);
      });
    this.setState({ modeArr: sourceObject });
  };

  saveCounsellorFxn = async (record) => {
    this.setState({ load: true });
    let x = await Request.saveCounsellor(record);

    if (x && !x.error) {
      notification.success({
        message: x.message,
      });

      this.table.current.reload();
      this.setState({ load: false, visible: false });
    } else {
      notification.error({ message: "Try again" });
    }
  };

  deleteRawInquiry = async (record) => {
    this.setState({ load: true });
    let x = await Request.deleteRawInquiry({ _id: record._id });

    if (x && !x.error) {
      notification.success({
        message: x.message,
      });

      this.table.current.reload();
      this.setState({ load: false });
    } else {
      notification.error({ message: "Try again" });
    }
  };

  moveSelectedRawInquiry = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      this.setState({
        selectedUsers: userArr,
        showMoveMultipleInquiries: true,
      });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  assignMultipleCounsellors = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      this.setState({
        assignCounsellorUsers: userArr,
        showMoveMultipleInquiries: true,
      });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  moveRawInquiryToVisitor = async (record) => {
    this.setState({ load: true })
    let x = await Request.moveRawToVisitorVisa(record)
    if (x && !x.error) {
      notification.success({
        message: "Moved To Visitor Visa"
      })
    } else {
      notification.error({ message: 'Try again' })
    }

    this.setState({ load: false }, () => {
      this.table.current.reload()
    })
  }

  moveRawInquiry = async (record) => {
    this.setState({ load: true });
    if (record.totalPreference && record.totalPreference.length === 0) {
      return notification.error({ message: "Add Preferred Country" });
    }
    if (!record.counsellorId) {
      return notification.error({ message: "Counsellor Not Assigned" });
    } else {
      let x = await Request.moveAndDeleteRawInquiry(record);

      if (x && !x.error) {
        notification.success({
          message: x.msg,
        });

        this.table.current.reload();
        this.setState({ load: false });
      } else {
        notification.error({ message: x.msg });
        // notification.error({ message: 'Try again' })
      }
    }
  };

  closeCallDrawer = () => {
    this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
      this.reload()
    })
  }

  handleSubmit = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);

        let x = null;

        x = await Request.addExcelData(values.excelFile[0].response);

        if (!x.error) {
          notification.success({
            message: x.message,
          });

          this.setState({ visible1: false });
          this.table.current.reload();
        } else {
          notification.error({
            message: x.message,
          });
        }
      }
    });
  };

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      params.dropped = this.state.showDropped;
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }

      if (this.state.counsellorReassigned == true) {
        params.counsellorReassigned = this.state.counsellorReassigned;
      }

      if (!params.mode) {
        params.mode = { $nin: ["Facebook"] };
      }

      userCheckBox = {};
      let data = await Request.getAllRawInquiryList({
        ...params,
        regExFilters: [
          "studentName",
          "email",
          "mobile",
          "createdByUser.name",
          "updatedByUser.name",
        ],
        InquiryDate: this.state.time,
      });

      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false,
          };
        }
      });
      this.setState({
        count: data.total,
        allBranches: data.allBranches,
        followDuesCount: data.followUpsDuesCount,
        userCheckBox: userCheckBox,
        exportParams: params,
        campaignNamesArr: data.campaignNames,
      });
      resolve(data);
    });
  };

  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showEmail: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  deleteSelected = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      let response = await Request.deleteMultipleRawInquiries(counsellingData);
      if (response.success) {
        notification.success({
          message: response.message,
        });
      } else {
        notification.error({
          message: response.message,
        });
      }
      this.reload();
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showWhatsAppSms: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  exportExcel = async () => {
    const { exportParams, count } = this.state;
    exportParams.results = count;
    exportParams.count = count;
    let x = await Request.exportRawInquiryToExcel({ ...exportParams });
    // let x = await Request.exportUsersToExcel({
    //      regExFilters: ['name'
    //     ]
    // })
    if (!x.error) {
      window.open(x.url);
    }
  };

  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showSMS: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  chooseRangerPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        time: {
          key: "time",
          $gte: date[0],
          $lt: date[1],
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };
  chooseRegistrationPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        registrationTime: {
          $gte: date[0],
          $lt: date[1],
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };
  followUpsCallback(isFollowUpOverdue) {
    this.setState(
      {
        isFollowUpOverdue: isFollowUpOverdue,
      },
      () => {
        this.table.current.reload();
      }
    );
  }
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  dropLeads = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      let response = await Request.dropRawInquiry(counsellingData);
      if (response.success) {
        notification.success({
          message: response.message,
        });
      } else {
        notification.error({
          message: "Something Went Wrong",
        });
      }
      this.table.current.reload();
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  toggleDroppedLeads = () => {
    let showDropped = this.state.showDropped;
    showDropped = !showDropped;
    this.setState({ showDropped }, () => {
      this.table.current.reload();
    });
  };
  toggleAssignCounsellor = () => {
    let counsellorReassigned = this.state.counsellorReassigned;
    counsellorReassigned = !counsellorReassigned;
    this.setState({ counsellorReassigned }, () => {
      this.table.current.reload();
    });
  };

  openFollowUps = (record) => {
    studentObj = {
      name: record.studentName,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };

  closeEmail = () => {
    this.setState({ showEmail: false });
  };
  closeSMS = () => {
    this.setState({ showSMS: false });
  };
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false });
  };
  closeFollowUp = () => {
    this.setState({ showFollowUp: false });
    this.reload();
  };

  closeSyncForm = () => {
    this.setState({ showSyncForm: false });
    this.reload();
  };

  onOk = (value) => {
    this.reload();
  };
  reload = () => {
    this.table.current.reload();
  };

  async componentDidMount() {
    await this.getAllSource();
    await this.getAllFollowUpTypes();
    let { data } = await Request.loadSimpleCounsellor({
      results: 10000,
      atLevel: ["Counselling Desk"],
    });

    this.setState({
      allCounsellor: data,
      loading: false,
    });
  }

  closeMultipleMoveInquiries = () => {
    this.setState(
      {
        showMoveMultipleInquiries: false,
        selectedUsers: [],
        assignCounsellorUsers: [],
      },
      () => {
        this.table.current.reload();
      }
    );
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      const followupDate = moment(followUp.followUpDate).format("YYYYMMDD");
      return todayDate >= followupDate ? true : false;
    }
  };

  render() {
    const { dispatch } = this.props;
    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;
    let {
      allCounsellor,
      modeArr,
      allStatus,
      allTestTypes,
      allBranches,
      followUpTypes,
    } = this.state;

    const columns = [
      {
        title: 'Sr. No',
        key: 'serialNumber',
        fixed: true,
        width: 60,
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: "Actions",
        key: "operation",
        dataindex: "operation",
        fixed: true,
        width: 220,
        render: (text, record) => (
          <div className={styles.btnWrapper}>
            <span className={styles.userSelectCheckbox}>
              <Checkbox
                checked={
                  userCheckBox[record._id]
                    ? userCheckBox[record._id].isChecked
                    : false
                }
                onChange={(y) => {
                  this.selectUser(y, record._id);
                }}
              />
            </span>
            <Tooltip title="Choose Counsellor">
              <Button
                size={"small"}
                style={{ marginLeft: "5px" }}
                shape="circle"
                onClick={() => {
                  this.setState({ visible: true, inquiryId: record._id });
                }}
                icon="user"
              />
            </Tooltip>
            <Tooltip title="Edit Raw Inquiry">
              <Button
                className={styles.btn}
                size={"small"}
                shape="circle"
                style={{ marginLeft: "5px" }}
                href={`/rawInquiry/edit-rawInquiry?id=${record._id}`}
                icon="edit"
              />
            </Tooltip>

            <RightsWrapper myRight={"Student.delete"}>
              <Tooltip title="Delete Raw Inquiry">
                <Popconfirm
                  title="Are you sure to delete this Raw Inquiry?"
                  onConfirm={() => {
                    this.deleteRawInquiry({ _id: record._id });
                  }}
                  onCancel={() => {
                    console.log();
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    className={styles.btn}
                    size={"small"}
                    style={{ marginTop: "5px", marginLeft: "5px" }}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>

            <Tooltip title="Move To Visitor Visa">
              <Popconfirm
                title="Are you sure to move this Google Inquiry?"
                onConfirm={() => {
                  this.moveRawInquiryToVisitor(record)
                }}
                onCancel={() => {
                  console.log()
                }}
                okText="Yes"
                cancelText="No">
                <Button
                  className={styles.btn}
                  size={'small'}
                  style={{ marginLeft: '5px' }}
                  shape="circle"
                  icon="backward"
                />
              </Popconfirm>
            </Tooltip>

            <Tooltip title="Move Raw Inquiry">
              <Popconfirm
                title="Are you sure to move this Raw Inquiry?"
                onConfirm={() => {
                  this.moveRawInquiry(record);
                }}
                onCancel={() => {
                  console.log();
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  className={styles.btn}
                  size={"small"}
                  style={{ marginLeft: "5px" }}
                  shape="circle"
                  icon="forward"
                />
              </Popconfirm>
            </Tooltip>

            <Tooltip title="View followups">
              <Button
                className={styles.btn}
                shape="circle"
                size="small"
                style={{ marginLeft: "5px" }}
                onClick={() => this.openFollowUps(record)}
                icon="eye"
              />
            </Tooltip>
          </div>
        ),
      },

      {
        title: "ID",
        key: "id",
        dataIndex: "id",
        sorter: true,
        width: 80,
        fixed: true,
        searchTextName: "id",
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        dataIndex: "studentName",
        sorter: true,
        fixed: true,
        width: 150,
        searchTextName: "studentName",
        filterRegex: true,
        render: (text, record) => (
          <React.Fragment>
            <div
              className={
                this.followUpExtendedDate(
                  record.followUp ? record.followUp : ""
                )
                  ? "antd-pro-containers-student-inquiry-all-styles-followUpExtendedDate"
                  : ""
              }
            >
              <Tooltip title="View Student Profile">
                <a>{text}</a>
              </Tooltip>
            </div>
          </React.Fragment>
        ),
      },

      {
        title: "DOB ",
        width: 100,
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        searchDateName: "dateOfBirth",
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },

      {
        title: "MOB/WAP/Mail",
        key: "mobwap",
        dataIndex: "mobwap",
        width: 150,
        searchTextName: "MOB/WAP/Mail",
        render: (val, record) => {
          return (
            <div>
              <div>
                <span>
                  {record.mobile &&
                    record.mobile.length >= 10 &&
                    rightAuth.checkRights("ShowClickToCall.view") ? (
                    <Tooltip title="Start Call">
                      <Button
                        className="ant-btn ant-btn-primary"
                        onClick={() => {
                          this.setState({ showCallDrawer: true, recordForCall: record })
                        }}
                      // onClick={(e) => {
                      //   dispatch(showLoader());
                      //   Request.callInitiate({
                      //     mobile: record.mobile,
                      //   }).then(({ data, error, message }) => {
                      //     dispatch(hideLoader());
                      //     if (!error) {
                      //       notification.success({
                      //         message: message,
                      //       });
                      //     } else {
                      //       notification.error({
                      //         message: message,
                      //       });
                      //     }
                      //   });
                      // }}
                      >
                        Click To Call
                      </Button>
                    </Tooltip>
                  ) : (
                    record.mobile
                  )}
                </span>
              </div>
              <div>
                {record.watsupp && record.watsupp.length == 10 ? (
                  <Tooltip title="Share on Whatsapp">
                    <a
                      target={"_blank"}
                      style={{ textDecoration: "underline" }}
                      href={`http://api.whatsapp.com/send?phone=91${record.watsupp
                        }&text=&source=&data=`}
                    >
                      {record.watsupp}
                    </a>
                  </Tooltip>
                ) : (
                  record.watsupp
                )}
              </div>
              <div>
                <span>{record.emailId}</span>
              </div>
            </div>
          );
        },
      },
      {
        title: "Campaign Name",
        key: "campaignName",
        width: 200,
        filterRegex: true,
        filters:
          this.state.campaignNamesArr &&
          this.state.campaignNamesArr.map((x) => ({ value: x, text: x })),
        render: (val, row) => {
          return <div>{row.campaignName}</div>;
        },
      },
      {
        title: "Preference",
        key: "preference",
        searchTextName: "preference",
        width: 200,
        filterRegex: true,
        render: (val, row) => {
          return (
            <div>
              {row.preference ? (
                row.preference
              ) : row.totalPreference ? (
                <ul className={common.ul}>
                  {row.totalPreference &&
                    row.totalPreference.length &&
                    row.totalPreference.map((val, inde) => {
                      return (
                        <li key={inde}>
                          {val && val.country ? val.country : ""}
                        </li>
                      );
                    })}
                </ul>
              ) : null}
            </div>
          );
        },
      },
      {
        title: "Case History",
        key: "caseHistory",
        searchTextName: "caseHistory",
        width: 200,
        filterRegex: true,
        render: (val, row) => {
          return <div>{row.caseHistory}</div>;
        },
      },
      {
        title: "Follow Up",
        key: "followUp.followUpType",
        width: 200,
        dataIndex: "followUp",
        filters: followUpTypes.map((x) => ({ value: x, text: x })),
        render: (text, record) => {
          return <LatestFollowUp info={text} />;
        },
      },
      {
        title: "Inquiry Type",
        key: "selectInquiryType",
        width: 120,
        filters: ["IELTS", "STUDENT", "VISITOR"].map((x) => ({
          value: x,
          text: x,
        })),
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        width: 150,
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Branch",
        key: "studentBranchId",
        width: 120,
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record &&
                record.studentBranchId &&
                record.studentBranchId.branchName}
            </div>
          );
        },
      },
      {
        title: "Source",
        key: "location",
        width: 120,
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Expo Visit",
        key: "expoVisit",
        width: 120,
        filters: [
          {
            value: true,
            text: "Yes",
          },
          {
            value: false,
            text: "No",
          },
        ],
        render: (text, record) => {
          return (
            <div>
              <div>{record.expoVisit ? "Yes" : "No"}</div>
            </div>
          );
        },
      },
      {
        title: "Profile Completed",
        key: "profileCompleted",
        width: 120,
        filters: [
          {
            value: true,
            text: "Yes",
          },
          {
            value: false,
            text: "No",
          },
        ],
        render: (text, record) => {
          return (
            <div>
              <div>{record.profileCompleted ? "Yes" : "No"}</div>
            </div>
          );
        },
      },
      {
        title: "Contact Date",
        key: "contactDate",
        width: 110,
        render: (text, record) => (
          <div>
            {record.contactDate
              ? moment(record.contactDate).format(dateFormat)
              : "NA"}
          </div>
        ),
      },
      {
        title: "Contact Time",
        key: "contactPreferredTime",
        width: 110,
      },
      {
        title: "Way of Contact",
        key: "howToContact",
        width: 110,
      },
      {
        title: "Mode",
        key: "mode",
        width: 120,
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Status",
        key: "rawInquiryStatus",
        width: 120,
        filters: allStatus.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Test Type",
        key: "testType",
        width: 110,
        filters: allTestTypes.map((x) => ({ value: x.value, text: x.text })),
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        searchTextName: "updatedByUser",
        filterRegex: true,
        dataIndex: "updatedByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
      {
        title: "Created By",
        width: 150,
        key: "createdByUser",
        searchTextName: "createdByUser",
        filterRegex: true,
        dataIndex: "createdByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },
    ];

    const inputTypes = {
      fields: [
        {
          label: "Choose Excel File",
          key: "excelFile",
          type: "file",
          required: true,
        },
      ],
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 },
      },
    };
    return (
      <PageHeaderWrapper
        title={` Raw Inquiry List : ${this.state.count} `}
        subTitle={`Follow Up Overdue: ${this.state.followDuesCount}`}
        followUpsCallback={this.followUpsCallback}
      >
        {
          this.state.showCallDrawer ?
            <ClickToCallDrawer record={this.state.recordForCall} type="rawInquiry" onClose={this.closeCallDrawer} />
            : null
        }
        {this.state.showMoveMultipleInquiries ? (
          <MoveMultipleInquiries
            allCounsellor={this.state.allCounsellor}
            assignCounsellorUsers={this.state.assignCounsellorUsers}
            selectedUsers={this.state.selectedUsers}
            onClose={this.closeMultipleMoveInquiries}
          />
        ) : null}

        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}

        {this.state.showSyncForm ? (
          <SyncSpreadsheetForm onClose={this.closeSyncForm} />
        ) : null}
        {this.state.showEmail ? (
          <EmailDrawer
            counsellingData={counsellingData}
            onClose={this.closeEmail}
          />
        ) : null}
        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}
        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS
            counsellingData={counsellingData}
            type="rawInquiry"
            onClose={this.closeWhatsSMS}
          />
        ) : null}
        <Card style={{ marginBottom: 10 }}>
          <Col span={6}>
            <h4>FILTER BY CREATED DATE</h4>
            <RangePicker
              key={this.state.showDate ? "78" : "326"}
              showTime={{ format: "HH:mm" }}
              format="YYYY-MM-DD"
              placeholder={["Start Date", "End Date"]}
              onChange={this.chooseRangerPicker}
              onOk={this.onOk}
            />
          </Col>
          <Col span={4}>
            <h4>&nbsp;</h4>
            <Button
              className={styles.btn}
              style={{ marginLeft: "0.5rem" }}
              type="primary"
              onClick={() => this.assignMultipleCounsellors()}
            >
              Assign Counsellors
            </Button>
          </Col>
          <Col span={4}>
            <h4>&nbsp;</h4>
            <Button
              className={styles.btn}
              type="primary"
              onClick={() => {
                this.toggleAssignCounsellor();
                // this.toggleDroppedLeads();
              }}
            >
              {this.state.counsellorReassigned
                ? "Show All Leads"
                : "Show Assigned Leads"}
            </Button>
          </Col>
          <Col span={4}>
            <h4>&nbsp;</h4>
            <RightsWrapper myRight={"dropLead.view"}>
              <Popconfirm
                title="Are you sure to drop this inquiry?"
                onConfirm={() => {
                  this.dropLeads();
                }}
                onCancel={() => { }}
                okText="Yes"
                cancelText="No"
              >
                <Button className={styles.btn} type="primary">
                  Drop Selected Leads
                </Button>
              </Popconfirm>
            </RightsWrapper>
          </Col>
          <Col span={4}>
            <h4>&nbsp;</h4>
            <RightsWrapper myRight={"showDropLead.view"}>
              <Button
                className={styles.btn}
                type="primary"
                onClick={() => {
                  this.toggleDroppedLeads();
                }}
              >
                {this.state.showDropped
                  ? "Show All Leads"
                  : "Show Dropped Leads"}
              </Button>
            </RightsWrapper>
          </Col>
          <Col span={2}>
            <h4>&nbsp;</h4>
            <RightsWrapper myRight={"rawInquiry.view"}>
              <Button
                className={styles.btn}
                type="primary"
                onClick={() => window.open("/raw/inquiry/add", "_blank")}
              >
                Add
              </Button>
            </RightsWrapper>
          </Col>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <Row>
            <Col span={24}>
              <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                <Button
                  type={"primary"}
                  style={{ textAlign: "center" }}
                  onClick={() => {
                    this.setState({ visible1: true });
                  }}
                >
                  Add Excel File
                </Button>
                {rightAuth.checkRights("RawInquiryExcelExport.view") ? (
                  <Button
                    className={styles.btn}
                    style={{ marginLeft: "10px" }}
                    onClick={() => this.exportExcel()}
                  >
                    Export Excel
                  </Button>
                ) : null}

                <Button
                  className={styles.btn}
                  style={{ marginLeft: "10px" }}
                  type="primary"
                  onClick={() => this.deleteSelected()}
                >
                  Delete Selected
                </Button>

                <Button
                  className={styles.btn}
                  style={{ marginLeft: "10px" }}
                  type="primary"
                  onClick={() => this.moveSelectedRawInquiry()}
                >
                  Move Raw Inquiry
                </Button>

                <Button
                  style={{ marginLeft: "10px" }}
                  className={styles.btn}
                  type="primary"
                  onClick={() => this.showEmail()}
                >
                  Send E-mail
                </Button>

                <Button
                  style={{ marginLeft: "10px" }}
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.showSMS()}
                >
                  Send SMS
                </Button>

                <Button
                  style={{ marginLeft: "10px" }}
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.showWhatsAppSms()}
                >
                  {" "}
                  Whatsapp
                </Button>

                <Button
                  style={{ marginLeft: "10px" }}
                  className={styles.btn}
                  onClick={() => this.selectAllUserFxn()}
                >
                  Select Visible
                </Button>

                <Button
                  style={{ marginLeft: "10px" }}
                  className={styles.btn}
                  onClick={() => this.unselectAllUserFxn()}
                >
                  Unselect Visible
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
        <Card bordered={true}>
          <TableComp
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params, columns)}
            extraProps={{ scroll: { x: 1400 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>

        {this.state.visible && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                visible: false,
              });
            }}
            visible={this.state.visible}
            width={500}
          >
            <div>
              <Card style={{ marginBottom: "10px" }}>
                <h2
                  style={{
                    marginLeft: "11px",
                    marginTop: "13px",
                    color: "orange",
                  }}
                >
                  Choose Counsellor
                </h2>

                <div>
                  <Select
                    showSearch={true}
                    allowClear
                    optionFilterProp="children"
                    style={{
                      width: 214,
                      paddingRight: 16,
                      paddingLeft: 9,
                    }}
                    value={
                      this.state.counsellorId
                        ? this.state.counsellorId
                        : undefined
                    }
                    placeholder="Select Counsellor"
                    onChange={(counsellorId) => {
                      this.setState(
                        {
                          counsellorId: counsellorId && counsellorId.toString(),
                        },
                        () => {
                          this.table.current.reload();
                        }
                      );
                    }}
                  >
                    {allCounsellor.map((val, idn) => {
                      return (
                        <Option key={idn} value={val._id}>
                          {val.name}
                        </Option>
                      );
                    })}
                  </Select>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() =>
                      this.saveCounsellorFxn({
                        _id: this.state.inquiryId ? this.state.inquiryId : "",
                        counsellorId: this.state.counsellorId
                          ? this.state.counsellorId
                          : "",
                      })
                    }
                    style={{ marginLeft: "1%" }}
                    loading={this.state.loading}
                  >
                    SAVE
                  </Button>
                </div>
              </Card>
            </div>
          </Drawer>
        )}

        {this.state.visible1 && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                visible1: false,
              });
            }}
            visible={this.state.visible1}
            width={500}
          >
            <div>
              <Card bordered={true}>
                <div>
                  <Form
                    onSubmit={this.handleSubmit}
                    {...formItemLayout}
                    style={{ marginTop: 8 }}
                  >
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={inputTypes}
                      getFieldDecorator={getFieldDecorator}
                    />

                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginLeft: "10%" }}
                      loading={this.state.loading}
                    >
                      UPLOAD
                    </Button>

                    <a href={RawInquiryExcel} download={"inquiry-sample.xlsx"}>
                      <Button
                        type="default"
                        style={{ marginLeft: "10%" }}
                        loading={this.state.loading}
                      >
                        DOWNLOAD SAMPLE FILE
                      </Button>
                    </a>
                  </Form>
                </div>
              </Card>
            </div>
          </Drawer>
        )}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllRawInquiry);
